// extracted by mini-css-extract-plugin
export default {"statusSelect":"Product_statusSelect__4tjvX","selectContainer":"Product_selectContainer__OthFt","left":"Product_left__Ue0Sn"};